import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const HighSchoolIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      xmlSpace="preserve"
      role="img"
    >
      <title>{educationLevels().level1.label}</title>
      <path
        d="M848.5,265.2c1.2,0.4,2.5,0.6,3.7,0.6c5.3,0,10.2-3.4,11.9-8.8c2.4-7.6,5.3-15.1,8.6-22.3c2.9-6.3,0.1-13.7-6.2-16.6
    c-6.3-2.9-13.7-0.1-16.6,6.2c-3.7,8.2-7,16.6-9.7,25.2C838.3,256.1,841.9,263.1,848.5,265.2z"
      />
      <path
        d="M843.3,341.2c0.3,0,0.5,0,0.8,0c6.9-0.4,12.1-6.4,11.7-13.3c-0.3-4-0.4-8-0.4-12.7c0-3.8,0.1-7.5,0.3-11.2
    c0.4-6.9-4.8-12.8-11.7-13.2c-7-0.5-12.8,4.9-13.2,11.7c-0.2,4.2-0.4,8.4-0.4,13.5c0,4.5,0.2,9,0.5,13.5
    C831.2,336.1,836.7,341.2,843.3,341.2z"
      />
      <path
        d="M864.7,374.8c-2.1-6.6-9.1-10.2-15.7-8.1c-6.6,2.1-10.2,9.1-8.1,15.7c2.7,8.5,6,16.9,9.9,25.2c2.1,4.5,6.6,7.2,11.3,7.2
    c1.8,0,3.6-0.4,5.3-1.2c6.3-2.9,9-10.4,6.1-16.6C870,389.7,867.1,382.3,864.7,374.8z"
      />
      <path
        d="M666,257.6c1.7,5.3,6.6,8.7,11.9,8.7c1.3,0,2.5-0.2,3.8-0.6c6.6-2.1,10.2-9.1,8.1-15.7c-2.7-8.5-6-16.9-9.9-25.2
    c-2.9-6.2-10.3-9-16.6-6.1c-6.3,2.9-9,10.4-6.1,16.6C660.7,242.6,663.6,250.1,666,257.6z"
      />
      <path
        d="M682.1,367.2c-6.6-2.1-13.6,1.6-15.7,8.2c-2.4,7.6-5.3,15.1-8.6,22.3c-2.9,6.3-0.1,13.7,6.2,16.6c1.7,0.8,3.4,1.1,5.2,1.1
    c4.7,0,9.3-2.7,11.4-7.3c3.7-8.2,7-16.6,9.7-25.2C692.4,376.2,688.7,369.2,682.1,367.2z"
      />
      <path
        d="M674.9,304.5c0.3,4,0.4,8,0.4,12.7c0,3.8-0.1,7.5-0.3,11.2c-0.4,6.9,4.8,12.8,11.7,13.2c0.2,0,0.5,0,0.7,0
    c6.6,0,12.1-5.1,12.5-11.8c0.2-4.2,0.4-8.4,0.4-13.5c0-4.5-0.2-9-0.5-13.5c-0.4-6.9-6.6-12.2-13.3-11.7
    C679.7,291.6,674.5,297.6,674.9,304.5z"
      />
      <path
        d="M392.6,187c34.6,10.4,48.4,49.8,34.2,98c-2,6.6,1.8,13.6,8.5,15.5c1.2,0.3,2.4,0.5,3.5,0.5c5.4,0,10.4-3.5,12-9
    c18.1-61.6-2.9-114.6-51-129c-6.6-2-13.6,1.8-15.6,8.4C382.2,178,386,185,392.6,187z"
      />
      <path
        d="M12.5,1000h975c6.9,0,12.5-5.6,12.5-12.5V710.9c0-6.9-5.6-12.5-12.5-12.5H969V514.1c0-6.9-5.6-12.5-12.5-12.5H851.3
    c21.5-9.9,41.6-23.5,59.2-41.2c38.5-38.7,59.5-90.1,59.3-144.7c-0.2-54.6-21.7-105.9-60.5-144.4c-38.7-38.4-89.9-59.5-144.3-59.5
    c-0.2,0-0.4,0-0.5,0c-54.6,0.1-105.9,21.5-144.3,60.2c-79.4,79.9-78.8,209.6,1.3,289.1c17.5,17.4,37.4,30.7,58.6,40.4H414
    c51.2-33,93.7-94.9,115.1-168.8c35.5-122.9-4.6-228.5-97.3-256.8C386,62,339,71.3,299.3,101.1c2.5-27.1,11.7-66.3,43.8-76.6
    c6.6-2.1,10.2-9.1,8.1-15.7c-2.1-6.6-9.1-10.2-15.7-8.1c-47.1,15.1-58.8,67.9-61.4,101.2c-39.9-30.4-87.3-40-133.5-25.9
    C47.8,104.3,7.8,209.9,43.3,332.7c21.4,73.9,63.8,135.9,115.1,168.8H43.5c-6.9,0-12.5,5.6-12.5,12.5v184.4H12.5
    C5.6,698.4,0,704,0,710.9v276.6C0,994.4,5.6,1000,12.5,1000z M632.6,195.4c2.4,2.6,5.7,4.1,9.1,4.1c2.8,0,5.6-0.9,7.9-2.8
    c5.4-4.4,6.2-12.2,1.8-17.6c-0.3-0.4-0.6-0.7-0.9-1.1c32-26.7,71.9-41.3,114.1-41.4c0.1,0,0.3,0,0.4,0c42.1,0,82,14.4,114.1,40.9
    c-0.2,0.3-0.4,0.5-0.7,0.8c-4.3,5.4-3.5,13.3,1.9,17.6c2.3,1.9,5.1,2.8,7.8,2.8c3.3,0,6.4-1.5,8.8-3.9
    c30.6,33.1,47.7,75.7,47.9,121c0.2,45.3-16.5,87.9-46.7,121.1c-4.5-4.8-11.8-5.5-17-1.3c-5.4,4.4-6.2,12.2-1.8,17.6
    c0.3,0.4,0.6,0.7,0.9,1c-65.9,54.8-162.2,55-228.5,0.5c0.2-0.2,0.4-0.5,0.6-0.7c4.3-5.4,3.5-13.3-1.9-17.6
    c-5-4.1-12.2-3.4-16.7,1.1C570.7,369.3,570.2,264,632.6,195.4z M67.3,325.8c-32-110.7,0.4-201.5,80.6-225.9
    c45.4-13.8,92.5,0,129.3,37.8c0.1,0.1,0.2,0.1,0.3,0.2c0.8,0.8,1.8,1.4,2.8,1.9c0.4,0.2,0.7,0.6,1.2,0.7c1.4,0.6,2.9,0.8,4.4,0.9
    c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0,0c0.3,0,0.6,0,0.9,0c0.7,0,1.2-0.4,1.9-0.5c0.9-0.2,1.7-0.3,2.5-0.7c0.8-0.4,1.4-0.9,2.1-1.4
    c0.5-0.4,1.1-0.6,1.6-1.1c36.8-37.9,84-51.7,129.3-37.8c80.2,24.5,112.6,115.3,80.6,225.9c-21.1,73.2-64,133.3-114.8,160.8
    c-27.5,14.9-55.3,18.7-80.4,11.1c-6-1.8-11.9-4.4-17.7-7.6c-1.9-1.1-4-1.6-6.1-1.6s-4.2,0.5-6.1,1.6c-5.7,3.2-11.7,5.8-17.7,7.6
    c-25.1,7.6-52.9,3.8-80.4-11.1C131.3,459.1,88.4,399,67.3,325.8z M944,698.4H783.9V526.6H944V698.4z M667.5,698.4V526.6h91.4v171.9
    H667.5z M56,526.6h280c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0h306.3v171.9H56V526.6z M25,723.4h950V975H25V723.4z"
      />
      <path
        d="M558,775.3H114.3c-6.9,0-12.5,5.6-12.5,12.5v122.8c0,6.9,5.6,12.5,12.5,12.5H558c6.9,0,12.5-5.6,12.5-12.5V787.8
    C570.5,780.9,564.9,775.3,558,775.3z M126.8,800.3h94.7v97.8h-94.7V800.3z M545.5,898.1H246.5v-97.8h298.9V898.1z"
      />
      <path
        d="M844.4,780.5c-37.9,0-68.7,30.8-68.7,68.7s30.8,68.7,68.7,68.7c37.9,0,68.7-30.8,68.7-68.7S882.3,780.5,844.4,780.5z
     M844.4,893c-24.1,0-43.7-19.6-43.7-43.7s19.6-43.7,43.7-43.7c24.1,0,43.7,19.6,43.7,43.7S868.5,893,844.4,893z"
      />
    </svg>
  );
};

export default HighSchoolIcon;

HighSchoolIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
